module.exports = __webpack_public_path__ + "img/ocb.f1ef07b1.png";